import DdDefaultButton from '@/components/DdDefaultButton'

import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

import flowMixin from '@/mixins/flowMixins'

export default {
  name: 'DashBoard',
  mixins: [flowMixin],
  components: {
    DdDefaultButton,
    FullCalendar // make the <FullCalendar> tag available
  },
  data () {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        dateClick: this.handleDateClick,
        events: [
          { title: '予定①', date: '2021-11-01' },
          { title: '予定②', date: '2021-11-20' }
        ],
        weekends: false // initial value
      }
    }
  },
  methods: {
    handleDateClick: function (arg) {
      alert('date click! ' + arg.dateStr)
    },
    toggleWeekends: function () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // toggle the boolean!
    }
  }
}
